import { Channels } from 'generated-graphql/types';

export const CHANNEL_LABEL_BY_CHANNEL_VALUE: Record<Channels, string> = {
  [Channels.Whatsapp]: 'WhatsApp',
  [Channels.Sms]: 'SMS',
  [Channels.Email]: 'Email',
  [Channels.WebChat]: 'Web Chat',
  [Channels.WebChatViaEmail]: 'Web Chat via Email'
};
